import React from "react";
import { render } from "@testing-library/react";
import { IntlProvider } from "react-intl";
import { Provider } from "react-redux";
import { reduxForm } from "redux-form";
import configureStore from "configureStore";

import messages from "__fixtures__/messages.json";
import DEVICE_COMPATIBILITY_CHECKER from "../DEVICE_COMPATIBILITY_CHECKER"; // Import your component

const DecoratedComponent = reduxForm({ form: "testForm" })(
  DEVICE_COMPATIBILITY_CHECKER
);

describe("<DEVICE_COMPATIBILITY_CHECKER />", () => {
  let testStore;

  beforeAll(() => {
    const { store } = configureStore();
    testStore = store;
  });

  const renderComponent = (props = {}) => {
    return render(
      <Provider store={testStore}>
        <IntlProvider locale="en" messages={messages}>
          <DecoratedComponent {...props} />
        </IntlProvider>
      </Provider>
    );
  };

  it("expect to not log errors in console", () => {
    const spy = jest.spyOn(global.console, "error");
    renderComponent();
    expect(spy).not.toHaveBeenCalled();
  });

  it("should render and match the snapshot", () => {
    const {
      container: { firstChild }
    } = renderComponent();
    expect(firstChild).toMatchSnapshot();
  });

  it("renders the DeviceCompatibilityChecker component with default props", () => {
    // Render the component with no props
    const { getByText } = renderComponent();

    // Test if the rendered component has some default content
    expect(
      getByText("Check that your device is 5G compatible")
    ).toBeInTheDocument(); // Replace with actual default content
    expect(
      getByText("Here's how to ensure your device is 5G ready.")
    ).toBeInTheDocument(); // Replace with actual default content
    // You can add more assertions as needed for default props
  });

  it("renders the DeviceCompatibilityChecker component with specific props isEsimChecker false", () => {
    // Mock specific props
    const props = {
      data: {
        isEsimChecker: false,
        accordionTitle: "devices_not_support_esim",
        noteOnPhones: "esim_note_on_phones",
        headerTitle: "check_5g_device_compatibility",
        subTitle: "ensure_5g_ready",
        dropdownBrandProps: {
          field: "select_mobile_device_brand",
          label: "select_mobile_device",
          data: {
            isSearchable: true
          },
          placeholder: "select_brand",
          required: false
        },
        dropdownModelProps: {
          field: "select_mobile_device_model",
          label: "select_mobile_model",
          data: {
            isSearchable: true
          },
          placeholder: "select_model",
          required: false
        }
      },
      generic: {
        compatible_devices: [{ brand: "Apple" }, { brand: "Samsung" }]
      },
      addOns: [{ id: "de8d8ccb-3cf6-47a4-bfee-d8fc411722a5", name: "5G" }],
      is5GAddonSelected: true
      // Add any other props required by your component
    };

    // Render the component with specific props
    const { getByText } = renderComponent(props);

    // Test if the rendered component reflects the specific props
    expect(
      getByText("Check that your device is 5G compatible")
    ).toBeInTheDocument(); // Replace with actual default content
    expect(
      getByText("Here's how to ensure your device is 5G ready.")
    ).toBeInTheDocument(); // Replace with actual default content
    expect(getByText("Select your mobile device brand")).toBeInTheDocument();
    expect(getByText("Select your mobile device model")).toBeInTheDocument();
    // You can add more assertions as needed
  });

  it("renders the DeviceCompatibilityChecker component with isEsimChecker true", () => {
    // Mock props with isEsimChecker true
    const props = {
      data: {
        isEsimChecker: true,
        accordionTitle: "devices_not_support_esim",
        noteOnPhones: "esim_note_on_phones",
        esimDesc: "esim_description",
        dropdownBrandProps: {
          field: "select_mobile_device_brand",
          label: "select_mobile_device",
          data: {
            isSearchable: true
          },
          placeholder: "select_brand",
          required: false
        },
        dropdownModelProps: {
          field: "select_mobile_device_model",
          label: "select_mobile_model",
          data: {
            isSearchable: true
          },
          placeholder: "select_model",
          required: false
        }
      },
      generic: {
        compatible_devices: [{ brand: "Brand5" }, { brand: "Brand6" }]
      }
      // Add any other props required by your component
    };

    // Render the component with isEsimChecker true
    const { getByText } = renderComponent(props);

    // Test if the rendered component displays content for isEsimChecker true
    expect(getByText("Select your mobile device brand")).toBeInTheDocument();
    expect(getByText("Select your mobile device model")).toBeInTheDocument();
    // You can add more assertions as needed
  });
});
